/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import 'velocity-animate';
export default class ProductSelect {
  init() {
    $('.js-modal-thumb').on('click', (event) => {
      if ($('.js-modal-thumb').hasClass('selected')) {
        $('.js-modal-thumb').removeClass('selected');
      }
      $(event.currentTarget).addClass('selected');
      $('.js-modal-product-cover').attr('src', $(event.target).data('image-large-src'));
      $('.js-modal-product-cover').attr('title', $(event.target).attr('title'));
      $('.js-modal-product-cover').attr('alt', $(event.target).attr('alt'));
    });
    $(document).on('shown.bs.modal', '#product-modal', function(e) {
      setTimeout(function() {
        $('#product').find('.modal-dialog .js-modal-product-images').slick({
          infinite: false,
          vertical: true,
          slidesToShow: 5,
          verticalSwiping: true,
          slidesToScroll: 1,
          swipeToSlide: true,
          draggable: false,
          prevArrow: '<i class="fl-outicons-chevron1 arrow-up js-arrow-up"></i>',
          nextArrow: '<i class="fl-outicons-chevron2 arrow-down js-arrow-down"></i>'
        });
      }, 900);
    });
    $(document).on('hidden.bs.modal', '#product-modal', function(e) {
      $('#product').find('#main .js-modal-product-images.slick-slider').slick('unslick');
    })
  }
}



// WEBPACK FOOTER //
// ./js/components/product-select.js